var _polygon, _polygon2, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28.825,32.88 12.217,22.5 28.825,12.12 26.175,7.88 6.175,20.38 6.175,24.62 26.175,37.12 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.825,37.12 93.825,24.62 93.825,20.38 73.825,7.88 71.175,12.12 87.783,22.5 71.175,32.88 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 4.472,
    transform: "matrix(0.8321 0.5547 -0.5547 0.8321 20.8782 -23.9561)",
    width: 5,
    height: 36.056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5,70V47.5h-35V60H5v35h90V70H67.5z M90,90H10V65h27.5V52.5h25V75H90V90z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming);
export default __webpack_public_path__ + "static/media/programming.39939280767411aea914761c64c330ba.svg";
export { ForwardRef as ReactComponent };